import type { ApiSurface } from './login.js';
import { CUSTOMER_UNAUTHENTICATED_PREFIXES } from '../seo/catalog.js';

/** Sign-in (or anonymous auth entry) SCR route per surface — used by route guards. */
export const SIGN_IN_PATHS: Record<ApiSurface, string> = {
  customer: '/sign-in',
  /** Owner/manager email+password entry (architecture gap — not SCR-MER-001 sign-up). */
  merchant: '/merchant-sign-in',
  admin: '/admin-sign-in',
  business: '/corporate-sign-in',
};

/** Paths reachable without an access token (prefix match). */
export const PUBLIC_PATH_PREFIXES: Record<ApiSurface, readonly string[]> = {
  customer: CUSTOMER_UNAUTHENTICATED_PREFIXES,
  merchant: ['/merchant-sign-in', '/merchant-sign-up', '/pin-sign-in', '/sign-in', '/login'],
  admin: ['/admin-sign-in'],
  business: ['/corporate-sign-in', '/corporate-sign-up', '/accept-invite'],
};

export function isPublicPath(surface: ApiSurface, pathname: string): boolean {
  return PUBLIC_PATH_PREFIXES[surface].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
